import { Outlet } from "react-router-dom";

export const DashboardLayout = () => {
  return (
    <div>
      <main className="mx-6 my-4 lg:mx-8">
        <Outlet />
      </main>
    </div>
  );
};
